import { memo } from 'react'

type colorType = 'default' | 'danger'

const TrashComponent = ({ color }: { color: colorType }) => {
  let className: string
  switch (color) {
    case 'danger':
      className = 'fill-danger'
      break
    default:
      className = 'fill-white'
  }

  return (
    <svg
      width="22"
      height="26"
      viewBox="0 0 22 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 5.89153C22 4.54194 20.7621 3.4434 19.2398 3.4434H15.4411C15.4411 3.43331 15.4418 3.42382 15.4418 3.41373C15.4418 2.62736 15.2142 1.86532 14.8014 1.26828C14.2453 0.462325 13.3882 0 12.452 0H9.5493C8.61251 0 7.75601 0.462325 7.19861 1.26828C6.78575 1.86532 6.55825 2.62736 6.55825 3.41373C6.55825 3.42382 6.55825 3.43391 6.55891 3.4434H2.7602C1.23791 3.4434 0 4.54194 0 5.89153C0 6.73547 0.483789 7.48088 1.21917 7.92125L2.34333 22.4468C2.35805 24.4089 4.0396 26 6.10457 26H15.8968C17.9617 26 19.6433 24.4083 19.6573 22.4468L20.7815 7.92125C21.5162 7.48088 22 6.73547 22 5.89153ZM9.54863 1.44632H12.4514C13.1995 1.44632 13.8117 2.3318 13.8117 3.41373H8.1876C8.1876 2.3318 8.79987 1.44632 9.54797 1.44632H9.54863ZM2.7602 4.88973H19.2405C19.8634 4.88973 20.37 5.33899 20.37 5.89153C20.37 6.37463 19.9825 6.77879 19.4686 6.87256H2.53203C2.01813 6.77879 1.6307 6.37463 1.6307 5.89153C1.6307 5.33899 2.13723 4.88973 2.7602 4.88973ZM18.0287 22.3714C18.0273 22.388 18.0266 22.4041 18.0266 22.4207C18.0266 23.597 17.0711 24.5537 15.8961 24.5537H6.1039C4.92889 24.5537 3.97336 23.597 3.97336 22.4207C3.97336 22.4041 3.97336 22.388 3.97135 22.3714L2.88533 8.33966H19.1147L18.0287 22.3714Z"
        className={className}
      />
      <path
        d="M10.9999 11.7568C10.5496 11.7568 10.1849 12.0809 10.1849 12.4797V19.9084C10.1849 20.3078 10.5496 20.6312 10.9999 20.6312C11.4503 20.6312 11.815 20.3072 11.815 19.9084V12.4797C11.815 12.0803 11.4503 11.7568 10.9999 11.7568Z"
        className={className}
      />
      <path
        d="M14.6013 13.2002C14.1509 13.2002 13.7863 13.5242 13.7863 13.9231V18.465C13.7863 18.8644 14.1509 19.1879 14.6013 19.1879C15.0516 19.1879 15.4163 18.8638 15.4163 18.465V13.9231C15.4163 13.5236 15.0516 13.2002 14.6013 13.2002Z"
        className={className}
      />
      <path
        d="M7.39863 13.2002C6.9483 13.2002 6.58362 13.5242 6.58362 13.9231V18.465C6.58362 18.8644 6.9483 19.1879 7.39863 19.1879C7.84896 19.1879 8.21364 18.8638 8.21364 18.465V13.9231C8.21364 13.5236 7.84896 13.2002 7.39863 13.2002Z"
        className={className}
      />
    </svg>
  )
}

export const Trash = memo(TrashComponent)
